import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface OrderInfoInput {
  zone_id?: number | null
  address?: string
  address_appartments?: string
  address_intercom?: string
  address_porch?: string
  address_floor?: string | null
  comment?: string | null
  no_door_call?: boolean
  door_delivery?: boolean
  assembly_method?: number
  customer_phone?: string | null
  receipt_email?: string | null
  payment_type?: string
  paymentToken?: GQL_ID
  cash_change?: string | number | null
  deliveryType?: string
  customer_geoposition?: {
    latitude?: number
    longitude?: number
  } | null
  slot_id?: number | null
  customerCourierMessage?: string | null
  recipientInfo?: {
    firstName?: string
    lastName?: string
    phone?: string
  }
}

interface UpdateOrderInfoVariables {
  order_id: GQL_ID
  orderInfo: OrderInfoInput
}

interface UpdateOrderInfoResponse {
  updateOrderInfo: {
    isOk: boolean
    notifySlotChanged: boolean
    orderInfo: {
      id: GQL_ID
      slot_id?: number | null
    }
  }
}

export const GQL_MUTATION_ORDER_UPDATE_INFO = gql`
  mutation updateOrderInfo($order_id: ID!, $orderInfo: OrderInfoInput) {
    updateOrderInfo: updateOrderInfoWithSlotCheck(
      order_id: $order_id
      orderInfo: $orderInfo
    ) {
      isOk
      notifySlotChanged
      orderInfo {
        id
        slot_id
      }
    }
  }
`

export const useMutateUpdateOrderInfo = () =>
  useMutation<UpdateOrderInfoResponse, UpdateOrderInfoVariables>(
    GQL_MUTATION_ORDER_UPDATE_INFO,
  )
